<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="epigraph">
<div class="epigraph">
<p class="epf"><a class="page" id="pvi"></a><a class="page" id="pvii"></a><span class="dropcap">I</span>t appears to me of preeminent importance to our science that we should become clear about the causal connections between goods.—Carl Menger, <i>Principles of Economics</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nyu-skousen-0006.vue?26d13607